import React from 'react'
import SEO from '../../../common/SEO';
import HeaderTwo from '../../../common/header/HeaderTwo';
import FooterOne from '../../../common/footer/FooterOne';
import AURAAgenticAIBanner from '../../../components/products/aura-agentic-ai/AURAAgenticAIBanner';
import WhatIsAgenticAI from '../../../components/products/aura-agentic-ai/WhatIsAgenticAI';
import AURAAgenticAIKeyFeatures from '../../../components/products/aura-agentic-ai/AURAAgenticAIKeyFeatures';
import AURAAgenticAIAction from '../../../components/products/aura-agentic-ai/AURAAgenticAIAction';
import AURAAgenticAIHybrid from '../../../components/products/aura-agentic-ai/AURAAgenticAIHybrid';
import FlexibleIntegration from '../../../components/products/aura-agentic-ai/FlexibleIntegration';

const AURAAgenticAI = () => {

  return (
    <>
      <SEO
				title="Edge AI"
				description="Deploy intelligent systems at the edge with our MEA (Machine Edge Analytics) product family."
      />
      <HeaderTwo styles="header-transparent header-style-2" searchDisable />
      <AURAAgenticAIBanner />
      <WhatIsAgenticAI />
      <AURAAgenticAIKeyFeatures />
      <AURAAgenticAIAction />
      <AURAAgenticAIHybrid />
      <FlexibleIntegration />
      <FooterOne />
    </>
  )
}

export default AURAAgenticAI;